"use client";

import { usePathname } from "@packages/i18n";
import { useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useUrl = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const getUrl = useCallback(() => {
    return `${window.location.origin}${pathname}?${searchParams.toString()}`;
  }, [pathname, searchParams]);

  const getUrlWithNewSearchParams = useCallback(
    ({ newSearchParams }: { newSearchParams: [[string, string]] }) => {
      const updatedSearchParams = new URLSearchParams(searchParams);

      newSearchParams.map(([key, value]) =>
        updatedSearchParams.append(key, value),
      );

      return `${window.location.origin}${pathname}?${updatedSearchParams.toString()}`;
    },
    [pathname, searchParams],
  );

  return { getUrl, getUrlWithNewSearchParams };
};
